<template>
  <v-list two-line>
    <template v-for="(n, index) in news">
      <v-list-item :key="n.id" :to="{ name: 'news', params: { id: n.id } }">
        <v-list-item-avatar tile size="50">
          <v-img :src="getImage(n)"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-lg mb-1">
            {{ n.title }}
          </v-list-item-title>

          <v-list-item-subtitle>
            {{ getDateTime(n.release_date) }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-list-item-action-text>
            <br />
            <v-chip small>
              {{ n.group_name }}
            </v-chip>
          </v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="index < news.length - 1" :key="`divider-${n.id}`"></v-divider>
    </template>
  </v-list>
</template>

<script>
import useAuth from "@/useAuth";
import { getDateTime } from "@/@core/utils/datetime_helpers";
import useNewsImage from "@/@core/utils/useNewsImage";

export default {
  props: ["news"],
  setup() {
    const { tenant } = useAuth();
    const { getPrimaryImage } = useNewsImage();

    const getImage = (n) => {
      const image = getPrimaryImage(n);
      return image.thumbnail;

      // if (Object.keys(n.image).length) {
      //   return n.image.thumbnail;
      // }
      // return tenant.value.logo.thumbnail;
    };

    return {
      getImage,
      getDateTime,
    };
  },
};
</script>

<style></style>